import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'bharatheal_contact_submissions';

const ContactSubmissionsContext = createContext(null);

export const ContactSubmissionsProvider = ({ children }) => {
    const [submissions, setSubmissions] = useState([]);

    useEffect(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                setSubmissions(JSON.parse(stored));
            }
        } catch (e) {
            console.error('Failed to load contact submissions:', e);
        }
    }, []);

    const addSubmission = useCallback((data) => {
        const newSubmission = {
            id: Date.now().toString(),
            ...data,
            submittedAt: new Date().toISOString(),
        };
        setSubmissions((prev) => {
            const updated = [newSubmission, ...prev];
            localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
            return updated;
        });
    }, []);

    const deleteSubmission = useCallback((id) => {
        setSubmissions((prev) => {
            const updated = prev.filter((s) => s.id !== id);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
            return updated;
        });
    }, []);

    return (
        <ContactSubmissionsContext.Provider value={{ submissions, addSubmission, deleteSubmission }}>
            {children}
        </ContactSubmissionsContext.Provider>
    );
};

export const useContactSubmissions = () => {
    const ctx = useContext(ContactSubmissionsContext);
    if (!ctx) throw new Error('useContactSubmissions must be used within ContactSubmissionsProvider');
    return ctx;
};